<template>
    <div>
        <div class="card-header">
            <div class="row justify-content-between">
                <div class="col-12 col-lg-4">
                    <SearchComponent v-model="filters.search" />
                </div>
                <div class="col-12 col-lg-4 my-3 text-right">
                    <div>
                        <Button @click="openModal()" class="descargarResumen">Descargar Resumen</Button>
                    </div>
                </div>
            </div>
        </div>
        <div class="card-body" v-if="!loading">
            <div class="table-responsive has-options">
                <table class="table table-hover text-nowrap">
                    <thead>
                        <tr>
                            <th class="text-center">CÓDIGO</th>
                            <th>NOMBRE</th>
                            <th>FECHA</th>
                            <th class="text-center">VENTAS TAQUILLA</th>
                            <th class="text-center">VENTAS ONLINE</th>
                            <th class="text-center">INVITACIONES</th>
                            <th class="text-center">TOTAL</th>
                            <th class="text-center">RECAUDACIÓN</th>
                        </tr>
                    </thead>
                    <tbody v-if="!loading">
                        <template v-for="(evento, index) in eventos.data">
                            <tr :key="index">
                                <td class="text-center">{{ evento.codigo }}</td>
                                <td>{{ evento.nombre_completo }}</td>
                                <td>{{evento.fecha_inicio}}</td>
                                <td class="text-center">{{ evento.taquilla.entradas_vendidas }}</td>
                                <td class="text-center">{{ evento.online.entradas_vendidas }}</td>
                                <td class="text-center">{{evento.invitaciones.entradas_vendidas}}</td>
                                <td class="text-center">{{ evento.taquilla.entradas_vendidas + evento.online.entradas_vendidas + evento.invitaciones.entradas_vendidas}}</td>
                                <td class="text-center">{{evento.online.singastos + evento.taquilla.singastos | formatear_precio}}</td>
                            </tr>
                        </template>
                    </tbody>
                    <tbody v-else>
                        <tr>
                            <td colspan="6">
                                <LoaderComponent></LoaderComponent>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="row justify-content-between">
                <div class="col-12 col-lg-3">
                    <ElementosPorPaginaComponent v-model="filters.per_page"></ElementosPorPaginaComponent>
                </div>
                <div class="col-12 col-lg-4" v-if="eventos">
                    <PaginateComponent
                    :current_page="eventos.meta.current_page"
                    :last_page="eventos.meta.last_page"
                    v-on:change_page="setPage"
                    ></PaginateComponent>
                </div>
            </div>
            <DescargarResumenVentas name="descargar-resumen" @close="closeModal"></DescargarResumenVentas>
        </div>
        <div class="card-body" v-else>
            <LoaderComponent></LoaderComponent>
        </div>
    </div>
</template>

<script>
import SearchComponent from "@/components/backend/components/SearchComponent";
import LoaderComponent from "@/components/preloader/LoaderComponent";
import PaginateComponent from "@/components/table/pagination/BackPaginateComponent";
import ElementosPorPaginaComponent from "@/components/backend/components/ElementosPorPaginaComponent";
import DescargarResumenVentas from "@/components/backend/eventos/Modal/DescargarResumenVentas";

export default {
    data() {
        return {
            eventos: null,
            loading: true,
            filters: {
                per_page: 10,
                page: 1,
                search: ""
            },
        }
    },
    created() {
        this.debouncedGetEventos = _.debounce(this.getEventos, 500);
        this.getEventos();
    },
    watch: {
        "filters.search"() {
            this.debouncedGetEventos();
        },
    },
    methods: {
        getEventos: function() {
            this.loading = true;
            const data = {
                filters: this.filters,
            };
            this.$store
                .dispatch(this.config.getVuexAlias("back.events.resumen-ventas"), data)
                .then(res => {
                    this.eventos = res.data;
                    this.loading = false;
                })
                .catch(error => {
                    this.loading = false;
                });
        },
        setPage(page) {
            this.filters.page = page;
            this.getEventos();
        },
        openModal() {
            this.$modal.show('descargar-resumen');
        },
        closeModal() {
            this.$modal.hide('descargar-resumen');
        },
    },
    components: {
        SearchComponent,
        LoaderComponent,
        PaginateComponent,
        ElementosPorPaginaComponent,
        DescargarResumenVentas
    }
}
</script>

<style scoped>
    @media (max-width: 700px) {
        .descargarResumen {
            width: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
        };
     }
</style>